export const SET_SERVICES='SET_SERVICES';
export const GET_SERVICE='GET_SERVICE';